import { Component, Injector, OnInit, ViewChild } from '@angular/core';
import { AccessRightFiltersComponent } from '@fi-shared/access-right-filters';
import { AccessRightFilterSettings } from '@fi-shared/access-right-filters';
import { ModuleType } from '@fi-shared/types/module-type';
import { ControlContainer, NG_VALIDATORS, NG_VALUE_ACCESSOR, NgForm } from '@angular/forms';
import { FiPageCollapsableContentComponent } from '@fi-app/components/fi-page-collapsable-content/fi-page-collapsable-content.component';
import { ControlValueAccessorValidatorBase } from '@fi-shared/control-value-accessor-validator-base';
import { ChecklistModel } from '@fi-app/checklist/checklist.model';
import { ObjectTypes } from '@fi-shared/types';

@Component({
    selector: 'fi-checklist-edit-sharing-selection',
    template: `
        <fi-page-collapsable-content [toggleIconPositionRight]="true">
            <fi-page-collapsable-content-title>{{
                'common.sharing_selection' | fiAppText
            }}</fi-page-collapsable-content-title>

            <fi-page-collapsable-content-subtitle>{{ selectedSelectionTitle }}</fi-page-collapsable-content-subtitle>

            <fi-access-right-filters
                [(ngModel)]="ngModel.AccessRightFilterCollection"
                (ngModelChange)="doPropagateChanges()"
                [accessRightFiltersSettings]="AccessRightFilterSettings"
                [quickChoiceTitleId]="'access_rights.quick_selections'"
                [autoSelectDefault]="!ngModel.Id"
                [isTooltipHidden]="isTooltipHidden()"
                [isHeaderHidden]="true"
                [isShared]="ngModel.PublicationSetting.IsShared"
                [showUserSelect]="false"
                [chooseUnitsColleaguesTextId]="'access_rights.and_or_units'"
                name="access-right-filters"
                (quickChoiceChange)="updateSelectedSelectionTitle($event)"
            ></fi-access-right-filters>
        </fi-page-collapsable-content>
    `,
    viewProviders: [
        {
            provide: ControlContainer,
            useExisting: NgForm,
        },
    ],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            multi: true,
            useExisting: FiChecklistEditSharingSelectionComponent,
        },
        {
            provide: NG_VALIDATORS,
            multi: true,
            useExisting: FiChecklistEditSharingSelectionComponent,
        },
    ],
    standalone: false,
})
export class FiChecklistEditSharingSelectionComponent
    extends ControlValueAccessorValidatorBase<ChecklistModel>
    implements OnInit
{
    @ViewChild(AccessRightFiltersComponent, { static: false }) accessRightFilters: AccessRightFiltersComponent;
    @ViewChild(FiPageCollapsableContentComponent, { static: false })
    collapsableContent: FiPageCollapsableContentComponent;

    AccessRightFilterSettings: AccessRightFilterSettings;
    selectedSelectionTitle: string;

    constructor(private injector: Injector) {
        super(injector);
    }

    ngOnInit(): void {
        const objectType = this.ngModel.IsTemplate ? ObjectTypes.CheckListTemplate : ObjectTypes.CheckList;
        this.AccessRightFilterSettings = new AccessRightFilterSettings(ModuleType.CheckList, false, true, objectType);
    }

    updateSelectedSelectionTitle(selectionTitle) {
        this.selectedSelectionTitle = selectionTitle;
    }

    isTooltipHidden() {
        return this.collapsableContent ? !this.collapsableContent.rollupContent.opened : true;
    }

    expandContent() {
        this.collapsableContent.expandContent();
    }
}
